export const DATE_FORMAT_TABLE = "D MMM YYYY";
export const DATETIME_FORMAT_TABLE = "D MMM YYYY HH:mm";
export const DATE_FORMAT_TABLE_SHORT = "DD/MM/YYYY";
export const DATETIME_FORMAT_TABLE_SHORT = "DD/MM/YYYY HH:mm";
